import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';

import { IPriceBook, IPriceBookSimple, IPriceBookUpdateDTO, IPriceBookViewDTO } from '../models/pricebook.model';
import { IPageCount } from 'src/app/shared/models/page.model';

/**
 * ╔════════════════════════════════════════════════════════════════════╗
 * ║                                                                    ║
 * ║                        Pricebook Actions                           ║
 * ║                                                                    ║
 * ║   All actions related to pricebook management in the application.  ║
 * ║   Includes loading pricebooks.                                     ║
 * ║                                                                    ║
 * ╚════════════════════════════════════════════════════════════════════╝
 */

// Get Pricebooks
export const GetPricebooks = createAction('[ Pricebooks ] - GetPricebooks',
    props<{ page: IPageCount; key?: string | undefined;}>()
);
export const GetPricebooksSuccess = createAction(
  '[ Pricebooks ] - GetPricebooks Success ',
    props<{ pricebooks: APIResponse<IPriceBookSimple> }>()
);
export const GetPricebooksError = createAction('[ Pricebooks ] - GetPricebooks Error');

// Get Pricebooks
export const AppendPricebooks = createAction('[ Pricebooks ] - AppendPricebooks',
  props<{ page: IPageCount; key?: string | undefined;}>()
);
export const AppendPricebooksSuccess = createAction(
'[ Pricebooks ] - AppendPricebooks Success ',
  props<{ pricebooks: APIResponse<IPriceBookSimple> }>()
);
export const AppendPricebooksError = createAction('[ Pricebooks ] - AppendPricebooks Error');

// Loader
export const SetPricebookLoader = createAction(
  '[ Pricebooks ] - SetPricebookLoader',
  props<{ isLoading: boolean }>()
);

// Create Pricebook
export const CreatePriceBook = createAction('[ Pricebooks ] - CreatePriceBook',
  props<{ pricebook: IPriceBook }>()
);
export const CreatePriceBookSuccess = createAction(
  '[ Pricebooks ] - CreatePriceBook Success',
  props<{ pricebook: IPriceBookSimple }>()
);
export const CreatePriceBookError = createAction('[ Pricebooks ] - CreatePriceBook Error');

// Get Pricebook by Id
export const GetPricebookById = createAction('[ Pricebooks ] - GetPricebookById',
  props<{ id: number }>()
);
export const GetPricebookByIdSuccess = createAction(
  '[ Pricebooks ] - GetPricebookById Success',
  props<{ pricebook: IPriceBookViewDTO }>()
);
export const GetPricebookByIdError = createAction('[ Pricebooks ] - GetPricebookById Error');

// Update Pricebook
export const UpdatePriceBook = createAction('[ Pricebooks ] - UpdatePriceBook',
  props<{ pricebook: IPriceBookUpdateDTO }>()
);
export const UpdatePriceBookSuccess = createAction(
  '[ Pricebooks ] - UpdatePriceBook Success',
  props<{ pricebook: IPriceBookSimple }>()
);
export const UpdatePriceBookError = createAction('[ Pricebooks ] - UpdatePriceBook Error');

// delete pricebook
export const DeletePricebook = createAction('[ Pricebooks ] - DeletePricebook',
  props<{ id: number }>()
);
export const DeletePricebookSuccess = createAction(
  '[ Pricebooks ] - DeletePricebook Success',
  props<{ id: number }>()
);
export const DeletePricebookError = createAction('[ Pricebooks ] - DeletePricebook Error');

// bulk delete pricebooks
export const BulkDeletePricebooks = createAction('[ Pricebooks ] - BulkDeletePricebooks',
  props<{ ids: number[] }>()
);
export const BulkDeletePricebooksSuccess = createAction(
  '[ Pricebooks ] - BulkDeletePricebooks Success',
  props<{ ids: number[] }>()
);
export const BulkDeletePricebooksError = createAction('[ Pricebooks ] - BulkDeletePricebooks Error');

// Enable Pricebooks
export const EnablePricebooks = createAction('[ Pricebooks ] - EnablePricebooks',
  props<{ ids: number[] }>()
);
export const EnablePricebooksSuccess = createAction(
  '[ Pricebooks ] - EnablePricebooks Success',
  props<{ ids: number[] }>()
);
export const EnablePricebooksError = createAction('[ Pricebooks ] - EnablePricebooks Error');

// Disable Pricebooks
export const DisablePricebooks = createAction('[ Pricebooks ] - DisablePricebooks',
  props<{ ids: number[] }>()
);
export const DisablePricebooksSuccess = createAction(
  '[ Pricebooks ] - DisablePricebooks Success',
  props<{ ids: number[] }>()
);
export const DisablePricebooksError = createAction('[ Pricebooks ] - DisablePricebooks Error');

// Toggle Pricebook for Catalog
export const TogglePricebookForCatalog = createAction('[ Pricebooks ] - TogglePricebookForCatalog',
  props<{ catalogId: number; pricebookId: number }>()
);
export const TogglePricebookForCatalogSuccess = createAction(
  '[ Pricebooks ] - TogglePricebookForCatalog Success',
  props<{ catalogId: number; pricebookId: number }>()
);
export const TogglePricebookForCatalogError = createAction('[ Pricebooks ] - TogglePricebookForCatalog Error');
